import { defaultTheme as theme } from '@automata/mui-theme';
import { useFlag } from '@automata/utils/hooks';
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useCallback, useMemo } from 'react';

import { selectLabwareDependencyEdges } from '../../../../../features/graph/selectors';
import { updateTaskProperties } from '../../../../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { PropertiesType } from '../../../../../types';

interface NoLabwareProps {
  isLabwareLessTask?: boolean;
  taskId: string;
}

export const NoLabware = ({ isLabwareLessTask, taskId }: NoLabwareProps) => {
  const dispatch = useAppDispatch();
  const edges = useAppSelector(selectLabwareDependencyEdges);
  const isLabwareLessTaskEnabled = useFlag('fe.utility_tasks');
  const taskLabwareOutputs = useMemo(() => {
    return edges.filter((edge) => edge.source === taskId);
  }, [edges, taskId]);

  const toggleLabwaresOfTask = useCallback(() => {
    dispatch(
      updateTaskProperties({
        id: taskId,
        propertiesType: PropertiesType.Action,
        isLabwareLessTask: !isLabwareLessTask,
      })
    );
  }, [dispatch, taskId, isLabwareLessTask]);

  return (
    <>
      {taskLabwareOutputs.length < 1 && isLabwareLessTaskEnabled && (
        <FormControlLabel
          sx={{ color: theme.palette.grey[700] }}
          control={
            <Checkbox
              id="no-labware-checkbox"
              checked={isLabwareLessTask}
              onChange={toggleLabwaresOfTask}
            />
          }
          label="Run task without labware"
        />
      )}
      {isLabwareLessTask && (
        <Card
          sx={{
            backgroundColor: theme.palette.grey[200],
            boxShadow: 'none',
          }}
        >
          <CardContent>
            <Typography>
              Set task dependencies to control the order of execution of tasks
              that use no labware.
            </Typography>
          </CardContent>
        </Card>
      )}
    </>
  );
};
